import React, { useState } from "react";
import { Formik } from "formik";
import {
  MimaButton,
  MimaDropdown,
  MimaInput,
  MimaText,
  MimaTextArea,
  Modal,
} from "../../components";
import moment from "moment";

const ViewMoreFeedback = ({
  loading,
  data,
  onSubmit,
  closeModal,
  validationSchema,
}) => {
  const [update, setUpdate] = useState(false);

  return (
    <Modal closeModal={closeModal}>
      <div style={{ width: "40rem" }}>
        <MimaText variant="subtitleBold" align="center" mb="7">
          Feedback Details
        </MimaText>
        <MimaText mb={2} labelTitle="Date & Time">
          {moment(data.createdAt).format("DD/MM/YYYY HH:mm a")}
        </MimaText>
        <MimaText mb={2} labelTitle="Business Name">
          {data.business.tradingName}
        </MimaText>
        <MimaText mb={2} labelTitle="Action Performed">
          {data.review}
        </MimaText>
        <MimaText mb={2} labelTitle="Response">
          {data.rating === 1
            ? "Terrible"
            : data.rating === 2
              ? "Bad"
              : data.rating === 3
                ? "Neutral"
                : data.rating === 4
                  ? "Good"
                  : "Amazing"}
        </MimaText>
        <MimaText mb={2} labelTitle="Suggestion">
          {data.review}
        </MimaText>
        <MimaText mb={2} labelTitle="Status">
          {data.status}
        </MimaText>

        {data.audits.length > 0 && (
          <MimaText labelTitle="Admin audit">{data?.audits[0].reason}</MimaText>
        )}
        {!update && data.status === "OPEN" && (
          <>
            <MimaButton
              title="Update Review"
              width={38}
              buttonColor="var(--color-dark)"
              onClick={() => {
                setUpdate(true);
              }}
            />
          </>
        )}
        <Formik
          initialValues={{
            reason: "",
          }}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            values,
            errors,
            touched,
          }) => (
            <>
              {update && (
                <>
                  <MimaTextArea
                    labelTitle="Reason"
                    name="reason"
                    placeholder="Enter reason"
                    value={values.reason}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.reason}
                    touched={touched.reason && errors.reason}
                  />

                  <MimaButton
                    title="Save"
                    width={38}
                    onClick={handleSubmit}
                    loading={loading}
                  />
                </>
              )}
            </>
          )}
        </Formik>
      </div>
    </Modal>
  );
};
export default ViewMoreFeedback;
